import { createFileRoute, notFound } from "@tanstack/react-router";
import { getIndustry, industrySlugs } from "@/lib/industries";
import { IndustryPage } from "@/components/IndustryPage";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { graph, serviceSchema, faqPage, breadcrumbList } from "@/lib/schema";

const AREA = [
  { type: "Country" as const, name: "Iraq" },
  { type: "Country" as const, name: "United Arab Emirates" },
  { type: "Country" as const, name: "Saudi Arabia" },
];

export const Route = createFileRoute("/industries/$slug")({
  beforeLoad: ({ params }) => {
    if (!industrySlugs.includes(params.slug)) throw notFound();
  },
  head: ({ params }) => {
    const ind = getIndustry(params.slug);
    if (!ind || !industrySlugs.includes(params.slug)) return {};
    const path = `/industries/${ind.slug}`;
    const url = absolute(path);
    return {
      meta: [
        { title: ind.metaTitle.en },
        { name: "description", content: ind.description.en },
        { property: "og:title", content: ind.metaTitle.en },
        { property: "og:description", content: ind.description.en },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { property: "og:image", content: OG_IMAGE },
        { name: "twitter:image", content: OG_IMAGE },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks(path)],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            graph(
              serviceSchema({
                path,
                name: ind.title.en,
                serviceType: `ISO certification for ${ind.name.en}`,
                description: ind.description.en,
                areaServed: AREA,
              }),
              faqPage(
                path,
                ind.faq.map((f) => ({ q: f.q.en, a: f.a.en })),
              ),
              breadcrumbList([
                { name: "Home", path: "/" },
                { name: "Industries", path: "/industries" },
                { name: ind.name.en, path },
              ]),
            ),
          ),
        },
      ],
    };
  },
  component: IndustryRoutePage,
});

function IndustryRoutePage() {
  const { slug } = Route.useParams();
  const ind = getIndustry(slug);
  if (!ind || !industrySlugs.includes(slug)) throw notFound();
  return <IndustryPage industry={ind} />;
}
